import { render, staticRenderFns } from "./My_Coin.vue?vue&type=template&id=04987a96&scoped=true"
import script from "./My_Coin.vue?vue&type=script&lang=js"
export * from "./My_Coin.vue?vue&type=script&lang=js"
import style0 from "./My_Coin.vue?vue&type=style&index=0&id=04987a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04987a96",
  null
  
)

export default component.exports